import { createFileRoute } from '@tanstack/react-router';
import { CrmHelpdeskAiContentPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/prompts/')({
  component: ContentListRoute,
});
function ContentListRoute() {
  const { locale } = Route.useParams();
  return <CrmHelpdeskAiContentPage locale={locale} kind="prompts" search={Route.useSearch()} />;
}
